import loadable from '@loadable/component';

const VirtualSportsLinkBar = loadable(
    () => import(/* webpackChunkName: "virtualsport-linkbar" */ './VirtualSportsLinkBar')
);

export default VirtualSportsLinkBar;
